import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css'
const Header = () => {
    return (
        <nav className='menu'>
            <div className='icon container'>
                <h2 className='fw-bold'><small className='fw-bold fs-2 text-danger '>Action</small> Figure</h2>
            </div>
            <div className='container'>
                <Link to="/">Home</Link>
                <Link to="/reviews">Reviews</Link>
                <Link to="/dashboard">Dashboard</Link>
                <Link to="/blogs">Blogs</Link>
                <Link to="/about">About</Link>
            </div>
        </nav>

    );
};

export default Header;